import React, { useState, useEffect } from 'react';
import { Page, Link, Icon } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';

const WalletUpdatePage = () => {
  const [data, setData] = useState({});  

  useEffect(() => {
    axios.get(API_BASE_URL + 'restwallet', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: {
          rest_id: localStorage.getItem('id'),
          limits: 100
        }
      })
      .then(response => { setData(response.data);} )
      .catch(error => console.log(error));
  }, []);
  // console.log(data);

  return (
    <Page className='bg-white'>
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/> */}
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
              <div className="container-lg custom-container p-0">
                <div className="header-panel">
                  <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon> <span className='text-dark d-none d-md-block'>Back</span></Link>
                  <h2>Wallet</h2>
                </div>
              </div>
            </header>
            <section className="payment method section-lg-b-space profile-form mt-3">
              <div className="custom-container p-0">
                <h4 className='fw-bolder mb-3'>Credit / Debit Card</h4>
                <div className="payment-list">
                  <ul className="cart-add-box payment-card-box gap-0 mt-3">

                  { data.length ? (
                  data.map(card => ( 
                    <li className="w-100">
                      <div className="payment-detail">
                        <div className="add-img">
                          <img className="img-fluid icon" src={require("./../img/icon/mastercard.svg").default} alt="mastercard" />
                        </div>
                        <div className="add-content">
                          <div>
                            <h5 className="fw-semibold dark-text">Mastercard **** **** {String(card.card_number).slice(-4)}</h5>
                            <h6 className="mt-1 light-text">Expires on {card.expire_date}</h6>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" defaultChecked />
                          </div>
                        </div>
                      </div>
                    </li>
                  )) 
                ) : (            
                  <></>
                )} 
                    <li className="new-card w-100">
                      <a href="/cardadd/" className="payment-detail">
                        <div className="add-img">
                          {/* <i className="ri-add-line theme-color add-square-img" /> */}
                          {/* <img src="https://cdn-icons-png.flaticon.com/128/1828/1828926.png" style={{width:"24px"}}/> */}
                          <Icon ios="material:add_circle" aurora="material:add_circle" md="material:add_circle" size={28}></Icon>
                        </div>
                        <div className="add-content">
                          <div>
                            <h5 className="fw-semibold dark-text">Add New Card</h5>
                            <h6 className="mt-1 light-text">Save and Pay via Cards.</h6>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>          
              </div>
            </section> 
          </div>
      </div>     
    </Page>
  );
}

export default WalletUpdatePage;